import { render, staticRenderFns } from "./modalValoresBeneficios.vue?vue&type=template&id=3e14a39b"
import script from "./modalValoresBeneficios.vue?vue&type=script&lang=js"
export * from "./modalValoresBeneficios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports